import axios from '../../axios';

const path = 'labels';
const service = {
  async createLabel(data) {
    return axios({ method: 'POST', url: path, data });
  },

  async addAnimalsToGroup({ id, data }) {
    return axios({ method: 'post', url: `${path}/${id}/animals`, data });
  },

  async fetchLabels(params) {
    return axios({ method: 'get', url: path, params });
  },

  async fetchLabel({ id, params }) {
    return axios({ method: 'get', url: `${path}/${id}`, params });
  },

  async updateLabel({ id, data }) {
    return axios({ method: 'put', url: `${path}/${id}`, data });
  },

  async deleteLabel(ids) {
    return axios({ method: 'delete', url: `/${path}/balk`, data: { ids } });
  },

  async removeAnimalsFromGroup({ id, data }) {
    return axios({ method: 'delete', url: `${path}/${id}/animals`, data });
  }
};

export default service;
